import { render, staticRenderFns } from "./reset_passwords.vue?vue&type=template&id=63e6a4cc"
import script from "./reset_passwords.vue?vue&type=script&lang=js"
export * from "./reset_passwords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports